import { Action } from 'redux';
import { put } from 'redux-saga/effects';
import { BasketActionTypes, BasketActions } from '../';
import { ErrorAction } from 'store';
import { ACTION_CREATOR_NAME, errorToBasketErrorModel } from 'helpers';
import { addProductSaga } from './addProduct';
import { initBasketPageSaga } from './initBasketPage';
import { BasketSagaReturnType, callBasketSaga } from 'store/sagaHelpers';

export interface AddDonationAction extends Action<BasketActionTypes.ADD_DONATION> {
    code: string;
    quantity: number;
}

export interface AddDonationActionStart extends Action<BasketActionTypes.ADD_DONATION_START> {
}

export interface AddDonationActionSuccess extends Action<BasketActionTypes.ADD_DONATION_SUCCESS> {
}

export interface AddDonationActionError extends ErrorAction<BasketActionTypes.ADD_DONATION_ERROR> {
}

export const addDonation: (code: string, quantity: number) => AddDonationAction = (code: string, quantity: number) => ({
    type: BasketActionTypes.ADD_DONATION,
    code,
    quantity
});
addDonation[ACTION_CREATOR_NAME] = 'addDonation';

export type AddDonationFunc = (...args: Parameters<typeof addDonation>) => void;

export function* addDonationSaga({ code, quantity }: AddDonationAction): BasketSagaReturnType {
    yield put<BasketActions>({
        type: BasketActionTypes.ADD_DONATION_START,
    });

    try {
        yield callBasketSaga(addProductSaga, {
            type: BasketActionTypes.ADD_PRODUCT,
            code,
            quantity
        });

        yield callBasketSaga(initBasketPageSaga, {
            type: BasketActionTypes.INIT_BASKET_PAGE
        });

        yield put<BasketActions>({
            type: BasketActionTypes.ADD_DONATION_SUCCESS
        });

        return true;
    } catch (error) {
        yield put<BasketActions>({
            type: BasketActionTypes.ADD_DONATION_ERROR,
            error: errorToBasketErrorModel(error, 'addDonationSaga')
        });

        return false;
    }
}